import CreateTemplate from './CreateTemplate.yaml?component';
import TemplatePreview from './TemplatePreview.yaml?component';
import Templates from './Templates.yaml?component';
import UcTemplate from './UcTemplate.yaml?component';
import UcTemplateSelector from './UcTemplateSelector.yaml?component';

export {
	CreateTemplate,
	TemplatePreview,
	Templates,
	UcTemplate,
	UcTemplateSelector
};
